import { useUser } from "@/api/user-query";

export default defineComponent({
	props: {
		author: { type: String, required: true },
	},
	setup(props) {
		const { t } = useI18n();

		const creator = toRef(props, "author");

		const { data: user } = useUser(creator);
		const author = computed(() => user.value?.name || t("common.unknown"));

		return () => (
			<div class="truncate text-xs">
				<span class="text-muted">{t("common.lastAuthor")}:</span>{" "}
				<span class="font-medium">{author.value}</span>
			</div>
		);
	},
});
